import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  resourceTypeId: 2,
  relationId: '',
  geometry: () => [],

  asParking: trait({
    resourceTypeId: 2,
    geometry: [
      () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
      () => faker.number.float({ min: 0, max: 1, precision: 0.0001 }),
    ],
  }),
});
